import { CardFocusTitle, GridCard } from '@components/GridCards/Common.styled';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import { useI18n } from '@i18n/useI18n';
import { createRef, useEffect, useRef, useState } from 'react';
import { Badge, BadgeRow, Bar, CounterNumber, CounterUnit, ExpRow, Fill, LevelRow, PraiseRow, StreakBadge } from './ProfileStreak.styled';

import LottieContent from './LottieContent/LottieContent';


// import svg icons for streak badges
import Streak0_Icon from '@assets/svg/streak/bronze_rank_0.svg';
import Streak1_Icon from '@assets/svg/streak/bronze_rank_1.svg';
import Streak2_Icon from '@assets/svg/streak/bronze_rank_2.svg';
import Streak3_Icon from '@assets/svg/streak/bronze_rank_3.svg';
import Streak4_Icon from '@assets/svg/streak/bronze_rank_4.svg';
import Streak5_Icon from '@assets/svg/streak/bronze_rank_5.svg';
import Streak6_Icon from '@assets/svg/streak/bronze_rank_6.svg';
import Streak7_Icon from '@assets/svg/streak/silver_rank_1.svg';
import Streak8_Icon from '@assets/svg/streak/silver_rank_2.svg';
import Streak9_Icon from '@assets/svg/streak/silver_rank_3.svg';
import Streak10_Icon from '@assets/svg/streak/silver_rank_4.svg';
import Streak11_Icon from '@assets/svg/streak/silver_rank_5.svg';
import Streak12_Icon from '@assets/svg/streak/silver_rank_6.svg';
import Streak13_Icon from '@assets/svg/streak/gold_rank_1.svg';
import Streak14_Icon from '@assets/svg/streak/gold_rank_2.svg';
import Streak15_Icon from '@assets/svg/streak/gold_rank_3.svg';
import Streak16_Icon from '@assets/svg/streak/gold_rank_4.svg';
import Streak17_Icon from '@assets/svg/streak/gold_rank_5.svg';
import Streak18_Icon from '@assets/svg/streak/gold_rank_6.svg';
import Streak19_Icon from '@assets/svg/streak/attender_rank_1.svg';
import Streak20_Icon from '@assets/svg/streak/attender_rank_2.svg';
import Streak21_Icon from '@assets/svg/streak/attender_rank_3.svg';
import Streak22_Icon from '@assets/svg/streak/attender_rank_4.svg';
import Streak23_Icon from '@assets/svg/streak/attender_rank_5.svg';
import Streak24_Icon from '@assets/svg/streak/attender_rank_6.svg';

// import lottie animation
import {
  Level1, Level2, Level3, Level4, Level5,
  Level6, Level7, Level8, Level9, Level10,
  Level11, Level12, Level13, Level14, Level15,
  Level16, Level17, Level18, Level19, Level20,
  Level21, Level22, Level23, Level24, Stor, Lille
} from '@models/StreakAnimation';

import RainbowLoader from '@components/Loaders/RainbowLoader';
import CardInfo from '@components/GridCards/CardInfo';

interface IProps {
  studentId: string,
  checkonly?: boolean
  updateTime?: any;
  guar?:boolean
}

export const ProfileStreak = (props: IProps) => {
  const i18n = useI18n();
  const { filterDate, settings } = useStore();
  const [streak, setStreak] = useState<any>();
  const [streakInfo, setStreakInfo] = useState({ level: 0, text: "", streakIcon: null, small: null })
  const [days, setDays] = useState({ current: 3, new: 5 })
  const [fillDays, setFillDays] = useState({ barLength: 0, fillLength: 0, maxLength: 0, minLength: 0 })
  const [levelAni, setLevelAni] = useState(false)
  const [finishAnimation, setFinishAnimation] = useState(false)
  const animationRunning = useRef(false)
  const animationsList = useRef(null)
  const [animations, setAnimations] = useState(null)
  const animationRefs = useRef(null)
  const [number, setNumber] = useState({ current: null, next: null, roll: false })
  const runAnimation = useRef(false)
  const [loading, setLoading] = useState(true)
  const timeouts = useRef([])
  const demo = useRef(false)
  const [day, setDay] = useState(null)
  const currentDay = useRef(null)
  const [time, setTime] = useState(1000)
  const [fill, setFill] = useState(0)
  const lastStreakJson = useRef<string>(null)

  const later = (fn: () => void, ms: number) => {
    const t = setTimeout(fn, ms)
    timeouts.current.push(t)
    return t
  }

  const clearTimers = () => {
    timeouts.current.forEach(t => clearTimeout(t))
    timeouts.current = []
  }

  useEffect(() => {
    GetStreakValue()
  }, [props.studentId, props.updateTime])

  const getAnimations = (oldDays: number, newDays: number, maxDays: number) => {
    let levels = [
      { level: 0, text: "streak-text-begin", streakIcon: <Streak0_Icon />, animation: Level1, barLength: 0, maxLength: 0, minLength: 0, small: true },
      { level: 1, text: "streak-text-1", streakIcon: <Streak1_Icon />, animation: Level1, barLength: 1, maxLength: 1, minLength: 0, textAnimation: Lille, small: true },
      { level: 2, text: "streak-text-2", streakIcon: <Streak2_Icon />, animation: Level2, barLength: 2, maxLength: 3, minLength: 1, textAnimation: Lille, small: true },
      { level: 3, text: "streak-text-3", streakIcon: <Streak3_Icon />, animation: Level3, barLength: 2, maxLength: 5, minLength: 3, textAnimation: Stor, small: false },
      { level: 4, text: "streak-text-4", streakIcon: <Streak4_Icon />, animation: Level4, barLength: 2, maxLength: 7, minLength: 5, textAnimation: Stor, small: false },
      { level: 5, text: "streak-text-5", streakIcon: <Streak5_Icon />, animation: Level5, barLength: 3, maxLength: 10, minLength: 7, textAnimation: Stor, small: false },
      { level: 6, text: "streak-text-6", streakIcon: <Streak6_Icon />, animation: Level6, barLength: 5, maxLength: 15, minLength: 10, textAnimation: Stor, small: false },
      { level: 7, text: "streak-text-7", streakIcon: <Streak7_Icon />, animation: Level7, barLength: 5, maxLength: 20, minLength: 15, textAnimation: Lille, small: true },
      { level: 8, text: "streak-text-8", streakIcon: <Streak8_Icon />, animation: Level8, barLength: 5, maxLength: 25, minLength: 20, textAnimation: Lille, small: true },
      { level: 9, text: "streak-text-9", streakIcon: <Streak9_Icon />, animation: Level9, barLength: 5, maxLength: 30, minLength: 25, textAnimation: Stor, small: false },
      { level: 10, text: "streak-text-10", streakIcon: <Streak10_Icon />, animation: Level10, barLength: 5, maxLength: 35, minLength: 30, textAnimation: Stor, small: false },
      { level: 11, text: "streak-text-11", streakIcon: <Streak11_Icon />, animation: Level11, barLength: 5, maxLength: 40, minLength: 35, textAnimation: Stor, small: false },
      { level: 12, text: "streak-text-12", streakIcon: <Streak12_Icon />, animation: Level12, barLength: 6, maxLength: 46, minLength: 40, textAnimation: Stor, small: false },
      { level: 13, text: "streak-text-13", streakIcon: <Streak13_Icon />, animation: Level13, barLength: 6, maxLength: 52, minLength: 46, textAnimation: Lille, small: true },
      { level: 14, text: "streak-text-14", streakIcon: <Streak14_Icon />, animation: Level14, barLength: 8, maxLength: 60, minLength: 52, textAnimation: Lille, small: true },
      { level: 15, text: "streak-text-15", streakIcon: <Streak15_Icon />, animation: Level15, barLength: 10, maxLength: 70, minLength: 60, textAnimation: Stor, small: false },
      { level: 16, text: "streak-text-16", streakIcon: <Streak16_Icon />, animation: Level16, barLength: 10, maxLength: 80, minLength: 70, textAnimation: Stor, small: false },
      { level: 17, text: "streak-text-17", streakIcon: <Streak17_Icon />, animation: Level17, barLength: 10, maxLength: 90, minLength: 80, textAnimation: Stor, small: false },
      { level: 18, text: "streak-text-18", streakIcon: <Streak18_Icon />, animation: Level18, barLength: 10, maxLength: 100, minLength: 90, textAnimation: Stor, small: false },
      { level: 19, text: "streak-text-19", streakIcon: <Streak19_Icon />, animation: Level19, barLength: 15, maxLength: 115, minLength: 100, textAnimation: Lille, small: true },
      { level: 20, text: "streak-text-20", streakIcon: <Streak20_Icon />, animation: Level20, barLength: 15, maxLength: 130, minLength: 115, textAnimation: Lille, small: true },
      { level: 21, text: "streak-text-21", streakIcon: <Streak21_Icon />, animation: Level21, barLength: 20, maxLength: 150, minLength: 130, textAnimation: Stor, small: false },
      { level: 22, text: "streak-text-22", streakIcon: <Streak22_Icon />, animation: Level22, barLength: 25, maxLength: 175, minLength: 150, textAnimation: Stor, small: false },
      { level: 23, text: "streak-text-23", streakIcon: <Streak23_Icon />, animation: Level23, barLength: 25, maxLength: 200, minLength: 175, textAnimation: Stor, small: false },
      { level: 24, text: "streak-text-24", streakIcon: <Streak24_Icon />, animation: Level24, barLength: 25, maxLength: 225, minLength: 200, textAnimation: Stor, small: false },
    ]

    let animations = []
    let animationList = []
    let aniRefs = []

    let current = null
    let currentNumber = null

    for (let i = 0; i < levels.length; i++) {
      const e = levels[i];
      if (oldDays >= e.maxLength) {
        let text = e.text
        if (e.level === 0 && maxDays > 0) text = "streak-text-0"
        current = { level: e.level, text: text, streakIcon: e.streakIcon, small: e.small }
        currentNumber = { current: e.level, next: e.level + 1, roll: false }
      }
      else if (newDays >= e.minLength) {
        animations.push(e)
        let ref = createRef()
        aniRefs.push(ref)
        animationList.push(<LottieContent level={e.maxLength.toString()} ref={ref} key={"animation" + i} lottieObject={e.animation} animate={false} apear={true} resetBadge={false} textObject={e.textAnimation} />)
      }
    }
    setStreakInfo(current)


    setNumber(currentNumber)

    if ((animations.length > 0 && !animations[animations.length - 1].last)) {
      let lastAnim = animations[animations.length - 1];
      if (newDays < lastAnim.maxLength) lastAnim.last = true
      else {
        let last = levels.find(a => a.level === animations[animations.length - 1].level + 1)
        if (last) {
          animations.push({ ...last, last: true })

          let ref = createRef()
          aniRefs.push(ref)
          animationList.push(<LottieContent level={last.maxLength.toString()} ref={ref} key={"animation" + animationList.length} lottieObject={last.animation} animate={false} apear={true} resetBadge={false} textObject={last.textAnimation} />)
        }
      }
    }
    else if (animations.length === 0) {
      let last = levels.find(a => a.level === current.level + 1)
      if (last) {
        animations.push({ ...last, new: true })

        setFillDays({ barLength: last.barLength, fillLength: newDays - last.minLength, maxLength: last.barLength, minLength: last.minLength })
        let ref = createRef()
        aniRefs.push(ref)
        animationList.push(<LottieContent level={last.maxLength.toString()} ref={ref} key={"animation" + animationList.length} lottieObject={last.animation} animate={false} apear={true} resetBadge={false} textObject={last.textAnimation} />)
      }
    }

    animationRunning.current = true

    animations = animations.map(o => {
      let obj = Object.assign({}, o);
      delete obj.animation;
      delete obj.next;
      return obj
    })

    setAnimations(animationList);
    animationRefs.current = aniRefs
    animationsList.current = animations
  }

  useEffect(() => {
    if (streak && streak.length > 0) {
      let s = streak[0]
      let lowvalue = props.checkonly ? s.currentPeriodStreak : s.laststreak
      currentDay.current = demo.current ? s.laststreak : lowvalue
      setDay(demo.current ? s.laststreak : lowvalue)
      getAnimations(demo.current ? s.laststreak : lowvalue, s.currentPeriodStreak, s.maxPeriodStreak)
    }

  }, [streak])


  useEffect(() => {
    return () => {
      clearTimers()
      lastStreakJson.current = null
      setAnimations(null)
      animationRefs.current = []
      animationRunning.current = false;
      runAnimation.current = false;
      animationRefs.current = []
    }
  }, [props.studentId])


  function animateAdmin(current) {
    animationRefs?.current[0]?.current?.showBadge()
    setFill(current - animationsList.current[0].minLength)
    setFillDays({ barLength: animationsList.current[0].barLength, fillLength: current - animationsList.current[0].minLength, maxLength: animationsList.current[0].barLength, minLength: 0 })
  }


  const setText = (max, timerLength, fill, maxLength, animation) => {
    setFill(fill)
    setDay(day => {
      if (day + 1 < max) {
        later(() => {
          setText(max, timerLength, fill + 1, maxLength, animation)
        }, timerLength * 1000)
      }
      else setTime(1000)
      currentDay.current = day + 1
      animation?.changeLevel(day + 1)
      return day + 1
    })
  }

  const getTimerLength = (barLength) => {
    if (barLength > 10) return 5 / barLength
    else if (barLength < 5) return 1
    else return 0.5
  }


  function animate(index, prev?, last?, current?) {
    animationRefs?.current[index]?.current?.showBadge()
    if (!last) timeouts.current.push(setTimeout(() => {
      timeouts.current.push(setTimeout(() => {
        animationRefs.current[index]?.current?.startAnimation()
        later(() => {
          if (prev) prev.hideBadge()
          else if (!last) setFinishAnimation(true)
          setLevelAni(true)
          timeouts.current.push(setTimeout(() => setNumber(n => {
            setStreakInfo({ level: animationsList.current[index].level, text: animationsList.current[index].text, streakIcon: animationsList.current[index].streakIcon, small: animationsList.current[index].small })
            getNumbers(n.current, animationsList.current[index].level)
            return n
          }), 700))
          timeouts.current.push(setTimeout(() => {
            setLevelAni(false)
            setFill(0)
            setFillDays({ barLength: animationsList.current[index + 1] ? animationsList.current[index + 1].barLength : 0, fillLength: 0, maxLength: animationsList.current[index + 1] ? animationsList.current[index + 1].barLength : animationsList.current[index].barLength, minLength: 0 })
          }, 2000))
        }, 2400)
        timeouts.current.push(setTimeout(() => {
          if (animationRefs.current.length - 1 > index) animate(index + 1, animationRefs.current[index].current, animationsList.current[index + 1].last, current)
        }, 5100))
      }, getTime(animationsList.current[index].barLength)))
      setTime(getTime(animationsList.current[index].barLength))
      setText(currentDay.current + animationsList.current[index].barLength, getTimerLength(animationsList.current[index].barLength), 1, animationsList.current[index].barLength, prev)
      setFillDays({ barLength: animationsList.current[index].barLength, fillLength: animationsList.current[index].barLength, maxLength: animationsList.current[index].barLength, minLength: 0 })
    }, 1000))


    let timer = animationsList.current.length > 1 ? 1000 : 0
    if (last) {
      later(() => {
        if (animationsList.current.length > 1) setText(currentDay.current + current - animationsList.current[index].minLength, getTimerLength(animationsList.current[index].barLength), 1, animationsList.current[index].barLength, prev)
        else setFill(current - animationsList.current[index].minLength)
        setDay(streak[0].currentPeriodStreak)
        setFillDays({ barLength: animationsList.current[index].barLength, fillLength: current - animationsList.current[index].minLength, maxLength: animationsList.current[index].barLength, minLength: 0 })
      }, timer)
    }
  }

  const GetStreakValue = async () => {
    try {
      let streakValue = await db.GetStreak4Student(props.studentId, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE, props.checkonly === true)
      // A refresh must not replace the demo data or replay the animation for unchanged data.
      if (demo.current) return
      const json = JSON.stringify(streakValue)
      if (json !== lastStreakJson.current) {
        lastStreakJson.current = json
        clearTimers()
        setStreak(streakValue);
      }
      setLoading(false)
    }
    catch (e) {

    }
  }

  const getNumbers = (level, next) => {
    if (next) {
      setNumber({ current: level, next: next, roll: true })
      later(() => {
        setNumber({ current: next, next: next, roll: false })
      }, 400)
    }
  }


  useEffect(() => {
    if (animations && animations.length > 0 && !runAnimation.current) {
      let s = 0
      if (streak && streak.length > 0) s = streak[0].currentPeriodStreak
      if (props.checkonly && !demo.current) {
        animateAdmin(s)
      }
      else {
        animate(0, null, animationsList.current[0].last, s)
      }

    }
  }, [animations])

  const triggerDemo = async () => {
    for (let i = 0; i < timeouts.current.length; i++) {
      const element = timeouts.current[i];
      clearTimeout(element)
    }
    timeouts.current = []
    animationRunning.current = false;
    runAnimation.current = false
    animationRefs.current = []
    animationRunning.current = false;
    demo.current = true
    setStreakInfo({ level: 0, text: "streak-text-begin", streakIcon: <Streak0_Icon />, small: true })
    setFillDays({ barLength: 1, fillLength: 0, maxLength: 1, minLength: 0 })
    setFinishAnimation(false)
    setAnimations(null)
    let currentPeriodStreak = 111
    let maxPeriodStreak = 100
    let laststreak = 0
    let streakValue = [{ currentPeriodStreak, maxPeriodStreak, laststreak }]
    setStreak(streakValue);
  }

  const getTime = (barLength) => {
    let time = barLength * getTimerLength(barLength) * 1000
    return time
  }

  const getFillLength = (fillLength, barlength) => {
    if (barlength === 0) return 0
    else return fillLength / barlength * 100
  }

  return (
    <GridCard style={props.guar?{order:"998"}:null}>
      {loading ? <RainbowLoader /> :
        <StreakBadge>
          <CardFocusTitle>Attender Streaks</CardFocusTitle>
          <CardInfo text='info-text-streak' />
          <PraiseRow onClick={() => settings.DEMO || settings.DEMO === "true" ? triggerDemo() : null}>
            <span>{i18n.t(streakInfo.text)}</span>
          </PraiseRow>
          <BadgeRow small={streakInfo.small}>
            <Badge hide={finishAnimation} >
              {streakInfo.streakIcon}
              <span>{day}</span>
            </Badge>
            {animations}
          </BadgeRow>
          <LevelRow animate={levelAni} >
            <span>Level</span>
            <CounterUnit display={!(number.current > 9 || number.next > 9)} roll={number.roll && (Math.floor(number.current / 10) !== Math.floor(number.next / 10))}>
              <CounterNumber>{Math.floor(number.current / 10)}</CounterNumber>
              <CounterNumber>{Math.floor(number.next / 10)}</CounterNumber>
            </CounterUnit>
            <CounterUnit roll={number.roll}>
              <CounterNumber>{number.current % 10}</CounterNumber>
              <CounterNumber>{number.next % 10}</CounterNumber>
            </CounterUnit>
          </LevelRow>
          <ExpRow>
            <Bar>
              <Fill time={time} fill={getFillLength(fillDays.fillLength, fillDays.barLength)} />
              <span> {fill} / {fillDays.barLength}</span>
            </Bar>
          </ExpRow>
        </StreakBadge>}
    </GridCard>
  );
};

export default ProfileStreak;
